<template>
  <ui-card name="audience.driving_behavior" rounded :error="error">
    <score-collection :values="values" />
  </ui-card>
</template>

<script>
import { get, reduce, forEach, zipObject, map, sum } from 'lodash';
import { driving } from 'config/settings';
import UiCard from 'ui/containers/UiCard';
import ScoreCollection from 'views/charts/ScoreCollection';

export default {
  components: {
    ScoreCollection,
  },

  data() {
    return {
      types: driving.types,
    };
  },

  computed: {
    values() {
      return this.types.map(type => {
        return {
          label: `audience.driving_behavior.${type}`,
          value: this.scores[type],
        };
      });
    },

    scores() {
      return this.getScores();
    },

    users() {
      return this.$store.state.audience.users;
    },

    error() {
      if (
        this.$store.state.audience.filters.length &&
        this.users.length === 0
      ) {
        return 'no_results';
      }

      return '';
    },
  },

  methods: {
    getScores() {
      const types = this.types;
      const scores = zipObject(types, map(types, type => [])); // { foo: [], bar: [], ... }
      let values;
      let value;

      // partition scores
      forEach(this.users, user => {
        forEach(types, type => {
          if (user.car_behavior && user.car_behavior.scores) {
            values = user.car_behavior.scores.past.all;
            value = values[type];
            if (value >= 0) {
              scores[type].push(value);
            }
          }
        });
      });

      // average scores
      forEach(types, type => {
        const arr = scores[type];
        scores[type] = arr.length ? (sum(arr) / arr.length) * 100 : 0;
      });

      // return
      return scores;
    },
  },
};
</script>
